import { Toaster as Sonner, toast } from "sonner"
import { CircleCheck, CircleAlert } from "lucide-react"
import { useEffect, useState } from "react"

const Toaster = ({ ...props }) => {
  const [mobile, setMobile] = useState(typeof window !== "undefined" && window.innerWidth < 768)
  useEffect(() => {
    const on = () => setMobile(window.innerWidth < 768)
    window.addEventListener("resize", on)
    return () => window.removeEventListener("resize", on)
  }, [])
  return (
    <Sonner
      theme="light"
      position={mobile ? "top-center" : "bottom-right"}
      className="toaster group"
      icons={{
        success: <CircleCheck className="h-5 w-5 text-[#277A3F]" />,
        error: <CircleAlert className="h-5 w-5 text-danger" />,
      }}
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-white group-[.toaster]:text-ink group-[.toaster]:border group-[.toaster]:border-line group-[.toaster]:rounded-[10px] group-[.toaster]:shadow-[0_12px_32px_rgba(22,24,29,.14)] group-[.toaster]:font-sans",
          description: "group-[.toast]:text-ink-3",
          actionButton: "group-[.toast]:bg-ink group-[.toast]:text-white",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-ink-3",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
